import { memo /* useMemo */ } from 'react';
// import { Trans } from '@betty/i18n';
import { Box, Text } from '@betty/moonlight';
// import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { ACCEPTABLE_DOCUMENTS } from './AcceptableDocumentsBottomSheet.content';
import AcceptableDocumentsTableRow from './AcceptableDocumentsTableRow/AcceptableDocumentsTableRow';

function AcceptableDocumentsBottomSheet() {
  // const navigation =
  //   useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  // const components = useMemo(
  //   () => ({
  //     contactSupport: (
  //       <Text // TODO: make it gradient when the alignment fix is pushed into main branch
  //         variant="link-medium"
  //         onPress={() => navigation.navigate('Account')}
  //       />
  //     ),
  //   }),
  //   [navigation],
  // );

  return (
    <Box gap="space-400">
      <Text
        variant="body-m"
        locKey="acceptableDocumentsSubtitle"
        locNS="onboarding"
        color="darkSurfacePrimary"
        paddingTop="space-400"
      />
      <Box
        backgroundColor="secondaryBackground"
        borderRadius="radius-200"
        padding="space-200"
      >
        <AcceptableDocumentsTableRow
          titleKey="acceptableDocumentsHeaderTitle"
          descriptionKey="acceptableDocumentsHeaderDescription"
        />
        {ACCEPTABLE_DOCUMENTS.map((document) => (
          <AcceptableDocumentsTableRow
            key={document}
            titleKey={`acceptableDocuments${document}Title`}
            descriptionKey={`acceptableDocuments${document}Description`}
            descriptionVariant="body-s"
            borderTopWidth="border-width-050"
            borderColor="borderActive"
          />
        ))}
      </Box>
      {/* TODO: uncomment this line when the chat is integrated */}
      {/* <Text variant="body-m" color="darkSurfacePrimary">
        <Trans
          i18nKey="acceptableDocumentsHelp"
          ns="onboarding"
          components={components}
        />
      </Text> */}
    </Box>
  );
}

export default memo(AcceptableDocumentsBottomSheet);
